var urlParams;

;(function($, trackFindaEvents, productRoadBlock){

    var rnn = window.rnn;

    function scrollToError() {
        var $alertError = $('form .alert-error');
        if ($alertError.length) {
            $(window).scrollTop($alertError.offset().top - $('.contribute .banner').outerHeight());
        }
    }


    function callPhoneNumber(phoneNumber) {
        phoneNumber = phoneNumber.replace(/\s+/g, '');
        window.location.href = 'tel://' + phoneNumber;
    }

    function clickPhoneNumber(){
        $('[data-click-b64]').click(function(){
            trackFindaEvents.track_phoneclick($(this));
        });
        $("[data-click-to-call]").click(function() {
            var phoneNumber = atob($(this).data('click-to-call'));
            trackFindaEvents.track_phoneclick($(this));
            callPhoneNumber(phoneNumber);
        });

    }

    function trackWebsiteClicks(){
        $('.website-gaTrack').click(function(){
            trackFindaEvents.track_websiteclick($(this));
        });
    }

    function contactFormOnBlurChecks(){
        $('#adContactForm input').blur(function() {
            var $this = $(this);
            if($this.val()){
                $this.addClass('filled');
            }else{
                $this.removeClass('filled');
            }
        });
    }

    function resumePlaceholder(){
        $('#adContactForm .resume .input-large').attr('placeholder','Upload Your Resume');
    }

    function rePositionMotoringTitleIcons(){
        var $transmission = $('.transmission-type-icon'),
            $body = $('.body-type-icon'),
            $odometer = $('.odometer-icon');

        $('.acf-list').append($transmission).append($body).append($odometer);
    }

    function genJSLinks(){
        // some links need to be set after the template has rendered.
        $('#adDetail .hiddenPhone').click(function() {
            trackFindaEvents.track_phoneclick($(this));
        });

        $('.classifieds-search-result').each(function() {
            var $this = $(this);

            // make the ad text a link.
            var adText = $this.find('.description').html(),
                href = $this.find('.description').data('link'),
                $descEl = $this.find('.description');

            $descEl.html('<a class="ad-text-link" href="' + href + '">' + adText + '</a>');
        });
    }

    function clickAdvertiserDetails() {
         $("[data-click-advertiser-details]").click(function() {
            var $this = $(this);
            // we only want to send th event when the contact expands (not when it collapses)
            if (!$this.next().hasClass('expanded')) {
                trackFindaEvents.track_advertisercontactclick($this);
            }
        });
    }

    // Initialise Classifieds
    function initClassifieds() {
        scrollToError();
        rePositionMotoringTitleIcons();
        clickPhoneNumber();
        contactFormOnBlurChecks();
        resumePlaceholder();
        genJSLinks();
        clickAdvertiserDetails();
        trackWebsiteClicks();
    }

    rnn.modules.register('classifieds', {
        init: initClassifieds
    });

})(jQuery, window.rnn.modules.trackFindaEvents, window.rnn.modules.productRoadBlock);

(window.onpopstate = function () {
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

    urlParams = {};
    while (match = search.exec(query))
       urlParams[decode(match[1])] = decode(match[2]);
})();
